import React, { useEffect, useReducer } from "react";
import { useDispatch, useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";
import AgGridPaginatedTable from "../../components/AgGridPaginatedTable";
import {
  Box,
  Grid,
  Typography,
  Button,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  Input,
  TextField,
  InputAdornment,
} from "@mui/material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import FormDialog from "../../components/AddAccount";
import { accountsTable as tableDef } from "../../config/grid-column-defs";
import { useState } from "react";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import useErrorHandler from "../../hooks/useErrorHandler";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import { getTransactionList } from "../../api/transaction-list";
import {
  getUserAccounts,
  deleteAccountById,
  insertAccount,
  updatedAccount,
  getSubsidiary,
} from "../../api/accounts";
import DeleteAlertDialog from "../../components/DeleteDialog";
const emptyData = {
  //id: "",
  name: "",
  email: "",
  role: "",
  password: "",
  page_access: [],
};

export default function AccountsList() {
  //const navigate = useNavigate();
  const dispatch = useDispatch();
  const snackbar = useSnackbar();
  const errorHandler = useErrorHandler();
  const dialogAction = useSelector((state) => state.dialog);
  const { data: user } = useSelector((state) => state.user);
  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0);
  const [open, setOpen] = useState(false);
  const [addUpdate, setAddUpdate] = useState("");
  const [formData, setFormData] = useState(emptyData);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(-1);
  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  const [role, setRole] = useState("");
  const [inputValue, setInputValue] = useState("");
  function refreshTable() {
    setTableRefreshCount((prev) => prev + 1);
  }

  let obj = tableDef.find((o) => o.headerName === "Action");
  addAdditionalColumn(obj, dispatch);

  useEffect(() => {
    if (user.token) {
      getTransactionListTableData();
      getSubsidiaryData();
    }
  }, [user.token]);

  const [rowData, setRowData] = useState([]);
  const [subsdiaryRowData, setSubsidiaryRowData] = useState([]);
  const [totalCount, setTotalCount] = useState("");

  async function getTransactionListTableData() {
    try {
      const { data } = await getTransactionList(user.token);
      setRowData(data.data);
      setTotalCount(data.data.totalrecords);
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
    } finally {
      // setLoading(false)
    }
  }
  async function getSubsidiaryData() {
    try {
      const { data } = await getSubsidiary(user.token, {});
      setSubsidiaryRowData(data);
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
    } finally {
      // setLoading(false)
    }
  }

  async function getAccountsTableData(limit, offset) {
    try {
      const { data } = await getUserAccounts(user.token, { limit, offset,name:inputValue });
      return { rows: data.user, total: data.total, error: false };
    } catch (error) {
      console.log(error);
      //snackbar.showError("Error In Loading Data.");
      errorHandler(error);
      return { error: true };
    } finally {
      // setLoading(false)
    }
  }

  const handleFormCreate = async (
    e,
    newData,
    setSelectedNames,
    setSelectedSubsidiary,
    setForm
  ) => {
    e.preventDefault();
    const combineData = { ...newData };
    if (addUpdate === "ADD") {
      try {
        const { data } = await insertAccount(user.token, combineData);
        snackbar.showSuccess(data.msg);
        setOpen(false);
        setFormData(emptyData);
        setForm();
        setSelectedNames([]);
        setSelectedSubsidiary([]);
        refreshTable();
      } catch (error) {
        errorHandler(error);
      }
    } else {
      const { data } = await updatedAccount(user.token, formData.id, newData);
      snackbar.showSuccess(data.msg);
      setOpen(false);
      setForm();
      setFormData(emptyData);
      setSelectedNames([]);
      setSelectedSubsidiary([]);
      refreshTable();
    }
  };
  async function deleteAccount(id) {
    try {
      const { data } = await deleteAccountById(user.token, id);
      snackbar.showSuccess(data.msg);
      refreshTable();
    } catch (error) {
      errorHandler(error);
    }
  }

  function addAdditionalColumn(obj, dispatch) {
    if (user.role === "admin") {
      if (obj === undefined) {
        tableDef.unshift({
          headerName: "Action",
          field: "actions",
          maxWidth: 86,
          cellRendererFramework: (params) => (
            <Box>
              <Button
                className="actionIcon"
                onClick={() => {
                  dispatch({ type: "DIALOG", data: params.data });
                }}
              >
                <EditOutlinedIcon />
              </Button>
              <Button
                className="actionIcon"
                onClick={() => {
                  dispatch({ type: "DELETE", data: params.data });
                }}
              >
                <DeleteIcon />
              </Button>
            </Box>
          ),
        });
      }
    }
  }

  useEffect(() => {
    if (!dialogAction.type) return;
    switch (dialogAction.type) {
      case "DIALOG":
        dispatch({ type: "" });
        setRole(dialogAction.data.role);
        setFormData(dialogAction.data);
        setOpen(true);
        setAddUpdate("UPDATE");
        break;
      case "DELETE":
        // dispatch({ type: "" });
        setDeleteDialogOpen(true);
        // dispatch({ type: "" });
        // deleteAccount(dialogAction.data.id);
        break;
      default:
        break;
    }
  }, [dialogAction]);
  useEffect(() => {
    if (deleteId === -1) return;
    deleteAccountById(user.token, deleteId)
      .then((res) => {
        snackbar.showSuccess(res.data.msg);
        setDeleteId(-1);
        refreshTable();
        setDeleteDialogOpen(false);
      })
      .catch((err) => {
        errorHandler(err);
        setDeleteId(-1);
        setDeleteDialogOpen(false);
      });
  }, [deleteId]);
  useEffect(() => {
    refreshTable();
  }, []);

  const handleInputChange = async (event) => {
    setInputValue(event);
    refreshTable();
  };
  const handleResetChange = async () => {
    refreshTable();                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
    setInputValue("");
  };
  return (
    <>
      <Box className="viewBox">
        <Box className="viewDetilsBox">
          <Grid
            container
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            mr={6}
            ml={1}
          >
            <Box pl={0}>
              <Typography className="pageHeading" pl={0}>
                Accounts
              </Typography>
            </Box>

            <Grid item xs={12} sm={4} md={4}>
              {user.role === "admin" ? (
                <>
                  <Button
                    className="backBtn"
                    onClick={() => {
                      setRole("admin");
                      setFormData(emptyData);
                      setOpen(true);
                      setAddUpdate("ADD");
                    }}
                    startIcon={<AddOutlinedIcon />}
                    sx={{ mr: 2}}
                  >
                    Add New Account
                  </Button>
                </>
              ) : (
                <></>
              )}
            </Grid>
          </Grid>

          <Grid container ml={1} >
            {/* <Grid item xs={12} sm={4} md={4} className="m-b-10"> */}
              <TextField
                size="medium"
                id="search-input"
                // label="Search"
                placeholder="Name"
                variant="outlined"
                onChange={(event)=>handleInputChange(event.target.value)}
                value={inputValue}
                sx={{ 
                  width: '270px', 
                  marginBottom: '10px',
                  '& .MuiInputBase-root': {
                    height: '37px', 
                  }
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            {/* </Grid> */}
            { inputValue &&  <div style={{marginBottom:"2px"}}>
                            <Button
                              type="button"
                              style={{ color: "black" }}
                              onClick={(e) => handleResetChange(e)}
                            >
                              Reset
                            </Button>
                          </div>}
          </Grid>
          {/* ))} */}

          <AgGridPaginatedTable
            getTableRows={getAccountsTableData}
            columns={tableDef}
            perPage={10}
            refreshCounter={tableRefreshCount}
          />

          {role && (
            <FormDialog
              open={open}
              setOpen={setOpen}
              formData={formData}
              addUpdate={addUpdate}
              handleFormCreate={handleFormCreate}
              setRole={setRole}
              role={role}
              rowData={rowData}
              subsdiaryRowData={subsdiaryRowData}
              setFormData={setFormData}
            />
          )}
          <DeleteAlertDialog
            open={deleteDialogOpen}
            setOpen={setDeleteDialogOpen}
            setDeleteId={setDeleteId}
            rowId={dialogAction.data?.id}
          />
        </Box>
      </Box>
    </>
  );
}
